<template>
  <div class="de-wrap">
    <div class="de-card" role="status" aria-live="polite">
      <div v-if="stage === 'redeeming'" class="de-stage">
        <div class="de-spin" aria-hidden="true" />
        <h1>Unlocking your demo…</h1>
        <p>Preparing a sandbox you can click around in for the next week.</p>
      </div>

      <div v-else-if="stage === 'ok'" class="de-stage">
        <div class="de-check" aria-hidden="true">✓</div>
        <h1>Demo ready</h1>
        <p>Dropping you into the LMS — no login needed. Anything you do here is in a sandbox and won't persist.</p>
      </div>

      <div v-else class="de-stage de-stage--err" role="alert">
        <div class="de-x" aria-hidden="true">!</div>
        <h1>Demo link expired</h1>
        <p>{{ errorMessage }}</p>
        <div class="de-actions">
          <router-link class="de-btn" :to="{ path: '/pricing', query: { tab: 'demo' } }">Request a new demo</router-link>
          <router-link class="de-btn de-btn--ghost" to="/login">Sign in instead</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const API_BASE = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000/api';

export default {
  name: 'DemoEnter',
  data() {
    return {
      stage: 'redeeming', // redeeming | ok | error
      errorMessage: '',
    };
  },
  computed: {
    token() {
      return (this.$route.query.token || '').toString();
    },
  },
  async mounted() {
    if (!this.token || this.token.length < 20) {
      this.stage = 'error';
      this.errorMessage = 'Missing demo token in the URL.';
      return;
    }
    try {
      const { data, status } = await axios.post(
        `${API_BASE}/new-checkout/checkout/demo/redeem`,
        { token: this.token },
        { validateStatus: () => true },
      );
      if (status === 200 && data?.status === 'ok' && data?.token) {
        this.storeAuth(data);
        this.stage = 'ok';
        setTimeout(() => {
          window.location.assign('/?_=' + Date.now() + '#/dashboard');
        }, 1200);
        return;
      }
      this.stage = 'error';
      this.errorMessage = data?.message || 'Could not redeem this demo link.';
    } catch (e) {
      this.stage = 'error';
      this.errorMessage = e.response?.data?.message || 'Network error — please try again.';
    }
  },
  methods: {
    storeAuth(data) {
      // See PricingPage.vue#storeAuth — dashboard crashes if hot-admin-id
      // isn't set for company-admin role.
      try {
        localStorage.setItem('hot-token', data.token);
        localStorage.setItem('hot-user', data.role || '');
        localStorage.setItem('hot-email', data.email || '');
        localStorage.setItem('hot-logged-user', String(data.user_id || ''));
        localStorage.setItem('hot-user-full-name', data.full_name || '');
        localStorage.setItem('hot-user-id', String(data.user_id || ''));
        if (data.company_id) {
          localStorage.setItem('hot-admin-id', String(data.company_id));
          localStorage.setItem('hot-company-id', String(data.company_id));
        }
      } catch (e) { /* private mode — dashboard guard handles it */ }
    },
  },
};
</script>

<style scoped>
.de-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: radial-gradient(1000px 500px at 50% -10%, #1a1a1a, #0f0f0f);
  font-family: Inter, system-ui, sans-serif;
  color: #f4f4f4;
}
.de-card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  color: #1a1a1a;
  border-radius: 18px;
  padding: 36px 32px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.35);
  text-align: center;
}
.de-card h1 {
  font-size: 22px;
  font-weight: 700;
  margin: 18px 0 8px;
}
.de-card p {
  color: #555;
  font-size: 14.5px;
  line-height: 1.55;
  margin: 0 0 14px;
}
.de-spin {
  width: 50px;
  height: 50px;
  border: 4px solid #eee;
  border-top-color: #fe672c;
  border-radius: 50%;
  margin: 0 auto;
  animation: de-spin 0.8s linear infinite;
}
@keyframes de-spin { to { transform: rotate(360deg); } }
.de-check, .de-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}
.de-check { background: #fe672c; box-shadow: 0 6px 20px rgba(254, 103, 44, 0.35); }
.de-x { background: #c0392b; }
.de-actions { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; margin-top: 12px; }
.de-btn {
  display: inline-flex;
  align-items: center;
  padding: 11px 20px;
  font: 600 14px Inter, system-ui, sans-serif;
  color: #fff;
  background: #1a1a1a;
  border-radius: 10px;
  text-decoration: none;
}
.de-btn--ghost {
  background: transparent;
  color: #fe672c;
  border: 1.5px solid #fe672c;
}
.de-stage--err h1 { color: #c0392b; }
</style>
